export const config = {
    urlForStatic: "./facade-configurator/",
    requestFromNginx: false,

//    urlForRequest: "https://grandline-3d.ru/api/",
//    urlForFile: "https://grandline-3d.ru/api/get_file/",

    urlForRequest: "https://grandline-2d.compute.center/api/",
    urlForFile: "https://grandline-2d.compute.center/api/get_file/",

    backgroundPlanesOpacity: 0.5,
    renderer: "opencv" // opencv or threejs
};

